import './home-page/HomepageApp.css';

import React, { useState } from 'react';


const pricingPlans = [
  {
    title: 'Free',
    price: '0 ден.',
    features: [
      '1 месец бесплатен пробен период.',
      'Сите функции од Pro планот.',
    ],
  },
  {
    title: 'Standard',
    price: '799 ден./месечно',
    features: [
      'Целосен преглед и слобода на изменување на вашите резервации, услуги и работно време',
      'Месечен и неделен календар за подобар преглед на вашите резервации',
      'Неограничени резервации',
      'Ваш сопствен линк и QR код преку кој вашите клиенти можат брзо лесно и едноставно да резервираат без потреба од корисничка сметка',
      'Вашите клиенти можат да го следат статусот на своите резервации во реално време',
      'Додавање на редовни клиенти за брзо и лесно резервирање',
      'Презакажување на веќе направена резервација од клиентот, за кое што истиот ќе биде известен во реално време',
      'Техничка поддршка во рок од 24 часа и копче за пријавување на проблем',
    ],
  },
  {
    title: 'Pro',
    price: '999 ден./месечно',
    features: [
      'Сите функции од Standard планот',
      'Професионален месечен извештај',
      'Алатки за пресметување на месечни трошоци и профит планер',
      'Анализа на термините, услугите и вкупниот приход.',
      'Автоматско пресметување на НЕТО профит и маржа.',
      'Без чекање крај на месецот за достапност на месечниот извештај',
      'Пресметки и преглед во реално време',
      'Опција за преземање на извештаите во Excel/CSV',
      'Инстант Печати/PDF на вашиот месечен извештај',
    ],
  },
];

const featureRows = [
  {
    title: 'Современо дигитално искуство',
    text: 'BookPoint обезбедува беспрекорно и професионално корисничко искуство на мобилен, таблет и десктоп. Управувајте со резервации и бизнисот сигурно и ефикасно, каде и да се наоѓате.',
    image: '/final1.png',
    imageAlt: 'Devices',
    imageFirst: true,
  },
  {
    title: 'Едноставно закажување',
    text: 'Со BookPoint, закажувањето е брзо, лесно и едноставно. Клиентите можат да резервираат услуги со неколку кликања, без потреба од корисничка сметка, а вие имате целосен преглед на сите закажувања.',
    image: '/final2.png',
    imageAlt: 'Booking',
    imageFirst: false,
  },
  {
    title: 'Прегледен dashboard за секојдневен успех без стрес',
    text: 'BookPoint ви овозможува лесно и пријатно управување со резервации, клиенти и аналитика, сè на едно место.',
    image: '/final3.png',
    imageAlt: 'Dashboard',
    imageFirst: true,
  },
  {
    title: 'Месечна статистика и аналитика за вашиот раст',
    text: 'Сите важни бројки и анализи, достапни во секое време. Професионални алатки за анализа и преглед на приходите, трошоците и услугите.',
    image: '/final4.png',
    imageAlt: 'Analytics',
    imageFirst: false,
  },
];


function App() {
  const [showContactModal, setShowContactModal] = useState(false);
  const handleOpenContact = () => setShowContactModal(true);
const handleCloseContact = () => setShowContactModal(false);
  const [showPricingModal, setShowPricingModal] = useState(false);

  return (
    <div className="App marketing-home">
      <header className="marketing-header refined-header">
        <div className="header-content professional-header">
          <div className="logo-title-group">
            <div className="title-logo-row">
              <img
                src={process.env.PUBLIC_URL + '/logo.png'}
                alt="BookPoint Logo"
                className="app-logo-largest"
              />
            </div>
          </div>

          <div className="nav-buttons-group">
            
            <button className="nav-btn login-btn" onClick={() => window.open('/userdashboard', '_blank')}>
              Најави се
            </button>
          </div>
        </div>
      </header>

      <main className="marketing-main">
        <section className="marketing-hero refined-hero hero-variant-b">
  <div className="hero-top-line">BookPoint за модерен и организиран бизнис</div>

  <h2>
    Професионално управување со
    <span className="hero-accent-text"> резервации и клиенти</span>
  </h2>

  <p className="hero-subcopy">
    Едноставно, сигурно и прегледно решение за секој бизнис што сака
    подобра организација, повеќе контрола и помалку стрес во секојдневието.
  </p>

  <div className="hero-actions">
    <button className="marketing-button prominent-button" onClick={() => setShowPricingModal(true)}>
      Погледни ценовник
    </button>

    <button className="hero-secondary-btn luxury-secondary" onClick={handleOpenContact}>
      Контактирајте нè
    </button>
  </div>

  <div className="hero-mini-stats">
    <div className="hero-stat-card">
      <strong>Брзо</strong>
      <span>закажување</span>
    </div>
    <div className="hero-stat-card">
      <strong>Паметен</strong>
      <span>преглед</span>
    </div>
    <div className="hero-stat-card">
      <strong>Месечна</strong>
      <span>аналитика</span>
    </div>
  </div>

  <div className="hero-animation"></div>
</section>

        <section className="alternating-section">
          {featureRows.map((row) => (
            <div className="alt-row" key={row.title}>
              {row.imageFirst ? (
                <>
                  <div className="alt-col alt-col-small alt-col-left">
                    <img
                      src={process.env.PUBLIC_URL + row.image}
                      alt={row.imageAlt}
                      className="alt-img"
                    />
                  </div>
                  <div className="alt-col alt-col-big alt-col-right">
                    <div className="alt-text-block">
                      <h3>{row.title}</h3>
                      <p>{row.text}</p>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="alt-col alt-col-big alt-col-left">
                    <div className="alt-text-block">
                      <h3>{row.title}</h3>
                      <p>{row.text}</p>
                    </div>
                  </div>
                  <div className="alt-col alt-col-small alt-col-right">
                    <img
                      src={process.env.PUBLIC_URL + row.image}
                      alt={row.imageAlt}
                      className="alt-img"
                    />
                  </div>
                </>
              )}
            </div>
          ))}
        </section>

        <section className="marketing-cta refined-cta">
          <h3>
            Како и многу други функции и алатки
            <br />
            Подготвени сте да го трансформирате вашиот бизнис?
            <br />
            Дознајте повеќе, кликнете на копчето подолу и контактирајте нè!
          </h3>
          <div>
            <button className="marketing-button prominent-button" onClick={() => setShowPricingModal(true)}>
              Ценовник
            </button>
            <button className="marketing-button prominent-button" onClick={() => setShowContactModal(true)}>
              Контактирајте нè
            </button>
          </div>
        </section>
      </main>

      <footer className="marketing-footer">
        <p>&copy; {new Date().getFullYear()} BookPoint. Сите права задржани.</p>
      </footer>

      {showPricingModal && (
  <div className="pricing-modal-overlay" onClick={() => setShowPricingModal(false)}>
    <div className="pricing-modal-card" onClick={(e) => e.stopPropagation()}>
      <button className="contact-modal-close" onClick={() => setShowPricingModal(false)}>
        ×
      </button>

      <div className="pricing-modal-content premium-pricing">
        {pricingPlans.map((plan) => (
          <div
            className={`pricing-plan-col pricing-card ${plan.title === 'Pro' ? 'pro-plan' : ''}`}
            key={plan.title}
          >
            <h2>{plan.title}</h2>
            <div className="plan-price">{plan.price}</div>
            <ul>
              {plan.features.map((feature) => (
                <li key={feature}>
                  <span>●</span>
                  {feature}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  </div>
)}

      {showContactModal && (
  <div className="contact-modal-overlay" onClick={handleCloseContact}>
    <div className="contact-modal-card premium-contact-modal" onClick={(e) => e.stopPropagation()}>
      <button className="contact-modal-close" onClick={handleCloseContact}>×</button>

      <div className="contact-modal-badge">Контакт</div>

      <div className="contact-modal-content">
        <div className="contact-modal-left">
          <div className="contact-logo-shell">
            <img
              src={process.env.PUBLIC_URL + '/logo.png'}
              alt="BookPoint Logo"
              className="contact-modal-logo"
            />
          </div>
        </div>

        <div className="contact-modal-right">
          <h2 className="contact-modal-title">Контактирајте нè</h2>

          <p className="contact-modal-subtitle">
            За прашања, информации или соработка, пишете ни директно и ќе ви одговориме во најкраток можен рок.
          </p>

          <div className="contact-info-list">
            <div className="contact-info-item">
              <div className="contact-info-label">Email</div>
              <a className="contact-info-value" href="mailto:bookpoint26@outlook.com">
                bookpoint26@outlook.com
              </a>
            </div>

            <div className="contact-info-item">
              <div className="contact-info-label">Instagram</div>
              <a
                className="contact-info-value contact-info-link"
                href="https://instagram.com/bookpoint.mk/?hl=en"
                target="_blank"
                rel="noreferrer"
              >
                @bookpoint.mk
              </a>
            </div>
          </div>

          <div className="contact-actions">
            <a className="contact-action-btn primary-action" href="mailto:bookpoint26@outlook.com">
              Испрати email
            </a>

            <a
              className="contact-action-btn secondary-action"
              href="https://instagram.com/bookpoint.mk/?hl=en"
              target="_blank"
              rel="noreferrer"
            >
              Отвори Instagram
            </a>
          </div>

          <div className="contact-modal-message premium-message">
            Ќе ви одговориме во рок од 24 часа. Ви благодариме за вашиот интерес и доверба.
          </div>
        </div>
      </div>
    </div>
  </div>
)}
    </div>
  );
}

export default App;
